import useVaultStore, {
  useVaultStoreActions,
} from "@/stores/zustand/vault/useVaultStore";
import { BackButton } from "@/components/vault/viewer/stickers/tabs/BackButton";
import HUI from "@henge-inc/ui/v1_2";
import { License } from "@/types/enums";
import { UploadNextButton } from "@/components/vault/viewer/stickers/tabs/UploadNextButton";
import { useScreenStore } from "@/stores/useScreenStore";

interface TabButtonsProps {
  newName: string;
  setNewNameInputErrorMessage: (message: string) => void;
  newTagValueList: string[];
  setNewTagInputErrorMessage: (message: string) => void;
  newLicense: HUI.SelectItemInterface<License> | null;
  onCloseModal: () => void;
}

export const TabButtons = ({
  newName,
  setNewNameInputErrorMessage,
  newTagValueList,
  setNewTagInputErrorMessage,
  newLicense,
  onCloseModal,
}: TabButtonsProps) => {
  const isMobileScreen = useScreenStore((state) => state.isMobileScreen);

  const currentPage = useVaultStore((state) => state.currentPage);
  const currentTab = useVaultStore((state) => state.currentTab);
  const { setCurrentTab } = useVaultStoreActions();

  if (isMobileScreen) return null;
  if (currentPage === "uploader") {
    return (
      <>
        {currentTab !== "metadata" && (
          <BackButton
            onClick={() => {
              switch (currentTab) {
                case "show-window":
                  setCurrentTab("metadata");
                  break;
              }
            }}
          />
        )}
        <UploadNextButton
          newName={newName}
          setNewNameInputErrorMessage={setNewNameInputErrorMessage}
          newTagValueList={newTagValueList}
          setNewTagInputErrorMessage={setNewTagInputErrorMessage}
          newLicense={newLicense}
        />
      </>
    );
  }
  return null;
};
